import React, {Component} from 'react';
import './DrugTypeSummary.css';
import Card from "../../components/card/Card";
import CardHeader from "../../components/cardHeader/CardHeader";
import Label from "../../components/label/Label";
import Input from "../../inputs/input/Input";
import models from "../../model/models";
import toasts from "../../utils/toasts";
import mainAPI from "../../api/MainAPI";
import Button from "../../components/button/Button";
import ExportResupplyReportPopup from "../../popups/exportResupplyReportPopup/ExportResupplyReportPopup";

export default class DrugTypeSummary extends Component {
	constructor(props) {
		super(props);
		this.state = {metrics: []};
	}

	componentDidMount = async () => {
		const filter = {};
		if(this.props.unitId){
			filter.unit_id = this.props.unitId;
		}
		if(this.props.drugBoxId){
			filter.drug_box_id = this.props.drugBoxId;
		}
		const metrics = await mainAPI.drug.metrics(filter);
		this.setState({metrics});
	}

	_deployedCount = (type) => {
		const deployed = this.state.metrics.find((metric) => metric.drug_type === type && metric.unit_type === 'deployed') || {};
		return deployed.total || 0;
	};

	_supplyCount = (type) => {
		const supply = this.state.metrics.find((metric) => metric.drug_type === type && metric.unit_type === 'supply') || {};
		return supply.total || 0;
	};
	_expiredCount = (type) => {
		const expired = this.state.metrics.find((metric) => metric.drug_type === type && metric.unit_type === 'expired') || {};
		return expired.total || 0;
	};


	_totalCount = (type) => {
		return this._deployedCount(type) + this._supplyCount(type) + this._expiredCount(type);
	};

	_updateParValue = (value, drug_type) => {
		if (value != parseInt(value)) {
			return toasts.show('Enter a number');
		}
		let user_group = this.props.user_group || {};
		user_group.par_values[drug_type] = value;
		models.user_group.save(user_group);
	};

	_updateUnitParValue = (value, drug_type) => {
		if (value != parseInt(value)) {
			return toasts.show('Enter a number');
		}
		const {user_group} = this.props || {};
		const {unit_par_values} = user_group || {};
		user_group.unit_par_values = Object.assign({}, unit_par_values || {}, {
			[drug_type]: value,
		});
		models.user_group.save(user_group);
	}

	_renderTypes = () => {
		const {
			types: drug_types,
			user_group: {par_values = {}, unit_par_values = {}} = {par_values: {}, unit_par_values: {}}
		} = this.props || {user_group: {par_values: {}, unit_par_values: {}}};
		let display = [];
		for (let i in drug_types) {
			let type = drug_types[i].id;
			const deployed = this._deployedCount(type);
			const supply = this._supplyCount(type);
			const expired = this._expiredCount(type);
			const total = this._totalCount(type);
			if (this.props.hideEmpty && !total) {
				continue;
			}
			display.push(
				<div key={i} className="row">
					<Label gray-dark>{drug_types[i].name}</Label>
					<Label gray-dark>{deployed}</Label>
					<Label gray-dark>{supply}</Label>
					<Label gray-dark>{expired}</Label>
					<Label gray-dark>{total}</Label>
					{this.props.includePar && <><ParValue
						value={par_values[type]}
						onChange={(value) => {
							this._updateParValue(value, type);
						}}
					/>
						<ParValue
							value={unit_par_values && unit_par_values[type]}
							onChange={(value) => {
								this._updateUnitParValue(value, type);
							}}
						/></>}
				</div>
			);
		}
		return display;
	};

	_showExportPopup = () => {
		const { user_group: { unit_par_values = {} } = {} } = this.props || { user_group: { par_values: {}, unit_par_values: {} } };

		const hasUnitParValues = Object.keys(unit_par_values).some(drugType => {
			const unitParValue = parseInt(unit_par_values[drugType]);
			return unitParValue && unitParValue > 0;
		});

		if (!hasUnitParValues) {
			toasts.show('Set unit par values first');
			return;
		}

		window.popupController.show(ExportResupplyReportPopup, {
			onExport: this._exportReport,
			onClose: () => {
				window.popupController.hide(ExportResupplyReportPopup);
			}
		});
	};

	_exportReport = async (percentOverPar) => {
		try {
			const { user_group: {  unit_par_values = {} } = {} } = this.props || { user_group: { par_values: {}, unit_par_values: {} } };


			const metricsByUnit = await mainAPI.drug.metricsByUnit();
			const types = this.props.types || [];
			const allUnits = models.unit.objs();
			
			const unitData = {};
			const drugTypeMap = {};
			const unitNameMap = {};

			for (let i in types){
				drugTypeMap[types[i].id] = types[i].name;
			}

			Object.keys(allUnits).forEach(unitId => {
				const unit = allUnits[unitId];
				if (models.unit.isArchived(unit)) return;
				unitData[unitId] = {
					name: unit.name || 'Unknown Unit',
					drugs: {}
				};
				unitNameMap[unitId] = unit.name || 'Unknown Unit';
			});

			if (Array.isArray(metricsByUnit)) {
				metricsByUnit.forEach(metric => {
					const { unit_id, unit_name, drug_type, category, total } = metric;
					if (!unit_id) return;
					
					if (!unitData[unit_id]) {
						unitData[unit_id] = {
							name: unit_name || 'Unknown Unit',
							drugs: {}
						};
					}
					
					if (!unitData[unit_id].drugs[drug_type]) {
						unitData[unit_id].drugs[drug_type] = {
							notExpired: 0,
							expired: 0
						};
					}
					
					if (category === 'notExpired') {
						unitData[unit_id].drugs[drug_type].notExpired += total;
					} else if (category === 'expired') {
						unitData[unit_id].drugs[drug_type].expired = total;
					}
				});
			}

			const unitOrderTotals = {};
			const csvRows = [];
			csvRows.push('Unit,Drug Type,Current Total,Unit Par Value,Order Quantity');

			const sortedUnitIds = Object.keys(unitData).sort((a, b) => {
				const nameA = unitData[a].name.toLowerCase();
				const nameB = unitData[b].name.toLowerCase();
				return nameA.localeCompare(nameB);
			});

			const sortedDrugTypes = Object.keys(unit_par_values).filter(drugType => {
				const unitParValue = parseInt(unit_par_values[drugType]);
				return unitParValue && unitParValue > 0;
			}).sort((a, b) => {
				const nameA = (drugTypeMap[a] || a).toLowerCase();
				const nameB = (drugTypeMap[b] || b).toLowerCase();
				return nameA.localeCompare(nameB);
			});

			sortedUnitIds.forEach((unitId, unitIndex) => {
				const unit = unitData[unitId];
				let unitHasRows = false;
				
				sortedDrugTypes.forEach(drugType => {
					const unitParValue = parseInt(unit_par_values[drugType]);
					const drugData = unit.drugs[drugType] || { notExpired: 0, expired: 0 };
					const currentTotal = drugData.notExpired;
					
					const unitTargetPar = Math.ceil(unitParValue * (1 + percentOverPar / 100));
					const unitOrderQuantity = Math.max(0, unitTargetPar - currentTotal);
					
					if (unitOrderQuantity > 0) {
						csvRows.push(`"${unit.name}","${drugTypeMap[drugType] || drugType}",${currentTotal},${unitParValue},${unitOrderQuantity}`);
						unitHasRows = true;
						
						if (!unitOrderTotals[drugType]) {
							unitOrderTotals[drugType] = {
								name: drugTypeMap[drugType] || drugType,
								total: 0
							};
						}
						unitOrderTotals[drugType].total += unitOrderQuantity;
					}
				});
				
				if (unitHasRows && unitIndex < sortedUnitIds.length - 1) {
					csvRows.push('');
				}
			});

			csvRows.push('');
			csvRows.push('Grand Totals');
			csvRows.push('Drug Type,Total Order Quantity');
			Object.keys(unitOrderTotals).forEach(drugType => {
				const total = unitOrderTotals[drugType];
				csvRows.push(`"${total.name}",${total.total}`);
			});

			const csvContent = csvRows.join('\r\n');
			const encodedUri = encodeURI('data:text/csv;charset=utf-8,' + csvContent);
			const link = document.createElement('a');
			link.setAttribute('href', encodedUri);
			const dateStr = new Date().toISOString().split('T')[0];
			link.setAttribute('download', `resupply-report-${dateStr}.csv`);
			document.body.appendChild(link);
			link.click();
			link.parentNode.removeChild(link);
			
			toasts.show('Report exported successfully');
		} catch (error) {
			console.error('Error exporting report:', error);
			toasts.show('Error exporting report', 5000);
		}
	};

	render() {
		return (
			<Card className="g-drug-type-summary">
				<div className="g-drug-type-summary-header">
					<CardHeader className="title">Summary</CardHeader>
					{this.props.includePar && (
						<Button
							color="white"
							bg="blue"
							onClick={this._showExportPopup}
							className="export-button"
						>
							Export Resupply Report
						</Button>
					)}
				</div>
				<div className="top-row">
					<Label black>Type</Label>
					<Label black>Deployed</Label>
					<Label black>Supply</Label>
					<Label black>Expired</Label>
					<Label black>Total</Label>
					{this.props.includePar && <><Label black className={'par-header'}>Par Value</Label>
						<Label black className={'par-header'}>Unit Par Value</Label>
					</>}
				</div>
				<div className="list">{this._renderTypes()}</div>
			</Card>
		)
	}
}

class ParValue extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mode: 'view'
		};
	}

	_editMode = () => {
		this.setState({mode: 'edit'});
	};

	_viewMode = () => {
		this.setState({mode: 'view'});
	};

	onChange = () => {
		let value = this.input.getValue();
		parseInt(value);
		this.props.onChange(value);
		this._viewMode();
	};

	render() {
		if (this.state.mode === 'view') {
			return (
				<div className="par-value view">
					<Label gray-dark>{this.props.value} {this.props.value == 1 ? 'Vial' : 'Vials'}</Label>
					<Label bold blue onClick={this._editMode} className="edit">
						Edit
					</Label>
				</div>
			);
		} else {
			return (
				<div className="par-value edit">
					<Input gray-dark ref={(ref) => (this.input = ref)} value={this.props.value}/>
					<Label bold blue onClick={this.onChange}>
						Save
					</Label>
					<Label blue onClick={this._viewMode}>
						Cancel
					</Label>
				</div>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/cards/drugTypeSummary/DrugTypeSummary.jsx